//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";

import Loader from "./components/Loader";
import Cards from "./components/Cards";
import Header from "./components/Header";

export default {
	name: "SocialFeed",
  components: {
    Loader,
		Header,
		Cards
  },
	data: function () {
		return {};
	},
	computed: {
		...mapGetters(["socialData", "loading", "error"]),
	},
	methods: {
		...mapActions(["loadSocialData"]),
		getSocialData() {
			this.loadSocialData(this.$root.socialEndpoint);
		}
	},
	created() {
		this.getSocialData();
	}
};
